
import React, { useState } from 'react';
import './Contact.css';

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const Contact = () => {
  const [fullname, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!EMAIL_REGEX.test(email)) {
      setErrMsg('Please enter a valid email.');
      return;
    }

    const bookingData = {
      fullName: fullname,
      email,
      message,
      date: null,
      time: null,
      sessionType: 'contact'
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/counseling/book`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData)
      });

      if (response.ok) {
        setSubmitted(true);
        setErrMsg('');
      } else {
        setErrMsg('Failed to submit form. Please try again later.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrMsg('There was an error submitting your form. Please try again later.');
    }
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p>Have questions or need support? Fill out the form below and our team will get back to you soon.</p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <label htmlFor="name">Name</label>
        <input type="text" id="name" name="fullname" value={fullname} onChange={e => setName(e.target.value)} required />

        <label htmlFor="email">Email</label>
        <input type="email" id="email" name="email" value={email} onChange={e => setEmail(e.target.value)} required />

        <label htmlFor="message">Message</label>
        <textarea id="message" name="message" value={message} onChange={e => setMessage(e.target.value)} required />

        <button type="submit">Send Message</button>
      </form>
      {errMsg && <p className="error-message">{errMsg}</p>}
      {submitted && <p className="success-message">Thank you for contacting us! We'll respond as soon as possible.</p>}
    </div>
  );
};

export default Contact;
